module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/logout/logout.component.css
// module id = ./src/app/core/components/logout/logout.component.css
// module chunks = main